import React from 'react';
import PropTypes from 'prop-types';

import SingleDatePicker from 'fuse-ui/components/SingleDatePicker';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    noBoxShadow: {
        boxShadow: 'none'
    }
};

const SingleDatePickerFilter = ( { classes, dataAutomationId, date, onDateChanged } ) => {
    return (
        <div data-automation-id={dataAutomationId}>
            <SingleDatePicker
                className={classes.noBoxShadow}
                date={date}
                onDateChange={onDateChanged}
            />
        </div>
    );
};

SingleDatePickerFilter.propTypes = {
    classes: PropTypes.object,
    dataAutomationId: PropTypes.string,
    date: PropTypes.object,
    onDateChanged: PropTypes.func.isRequired,
};

export default withStyles( styles )( SingleDatePickerFilter );
